import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="pt-32 text-center text-ink2">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
